import { Component } from 'react'
import config from '@src/config'
import { REGISTER_COLUMNS, URLS } from '@src/constants'
import { Register, TabMedRecordsWithAudit, TabPersonalWithAudit, TabRouteWithAudit } from '@src/modules/monitoring/components'
import { TabStatusWithAudit } from './TabStatus'

export class RegisterAkineoPregnant extends Component {
  get basepath () {
    return URLS.MONITORING__AKINEO__PREGNANT
  }

  get navTitle () {
    return 'Реестр беременных'
  }

  get columns () {
    return [
      { type: REGISTER_COLUMNS.FULLNAME, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.SNILS, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.BIRTH_DATE, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.PATIENT_AGE, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.GESTATIONAL_AGE, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.PREGNANCY_OUTCOME, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.DIAGNOSIS, settings: { column: { enabled: true } } },
    ]
  }

  get tabs () {
    return [
      TabStatusWithAudit,
      TabMedRecordsWithAudit,
      TabPersonalWithAudit,
      ...(config.app.modules.enabled.monitoring_routes ? [TabRouteWithAudit] : []),
    ]
  }

  render () {
    return <Register
      list_type='3'
      columns={this.columns}
      basepath={this.basepath}
      navTitle={this.navTitle}
      tabs={this.tabs}
    />
  }
}
